import { WebGLRenderer, ACESFilmicToneMapping, PCFShadowMap } from 'three';

export class Setting 
{
	sizes:any = {
		width: document.body.clientWidth,
		height: window.innerHeight
	}
	content:HTMLElement | null = document.querySelector('.halloween-2025-map');
	canvas:HTMLElement | null = document.querySelector('canvas.webgl');
	mixer:any = null;
	glb:any = null;
	aniList:any = {};
	currentAni:any = null;
	currentHaunt:any = -1;
	hauntTotal:any = 6;
	to:any = null;
	basicScale:any = 0.1;
	infoSet:any = [
		{x:0, y:-2.5, z:0, px:0.2, py:-0.3, pz:0, cx:0.3, scale:this.basicScale, mixer:'Play_Click'},
		{x:0, y:-5.5, z:0, px:-0.3, py:.5, pz:0, cx:0.3, scale:this.basicScale, mixer:'Play_Idle'},
		{x:0, y:-2, z:0, px:0.5, py:1.1, pz:0, cx:0.3, scale:this.basicScale, mixer:'Play_Click'},
		{x:0, y:(2.1-Math.PI*2), z:0, px:-.4, py:1.2, pz:0, cx:0.3, scale:this.basicScale, mixer:'Play_Transition'},
		{x:0, y:.8, z:0, px:0, py:1.2, mpy:.6, pz:0.1, cx:-0.01, scale:this.basicScale, mixer:'Play_Transition'},
		{x:0, y:-1.1, z:0, px:0, py:1.8, pz:0, cx:0.3, scale:this.basicScale, mixer:'Play_Transition'},
	];
	constructor(){
	}
}